$(document).ready(function(){
  var a = $('.dynamic-testimonials-pagination-list .dynamic-testimonials-pagination-list-item').length;
  var count = $('.dynamic-testimonials-pagination-list .dynamic-testimonials-pagination-list-item').length;
  for (i = 0; i < a; i++) {
    var a = i + 1;
    setInterval(function(){ 
      if( i == count){i = 0;}
      var a = i++;
      var child = a + 1;
      $('.dynamic-testimonials-pagination-list .dynamic-testimonials-pagination-list-item:nth-child('+child+') .dynamic-testimonials-pagination-list-item-dot').trigger('click');
    }, 8000);   
//     set time to slick slide up
  }
//   ===== show forget password 
  $('.toggle-forgetfulness').click(function(){
    $('.customer-login').slideToggle();
    $('.recover-password').slideToggle();
  });
//   ===== show btn
  $('.product-form-submit-wrap .add-to-cart-button').click(function(){
    $(this).addClass('outline').removeClass('inverse');
    setTimeout(function(){
//             btn checkpot-recharge
//       $('.checkpot-recharge').addClass('show-btn-recharge');
      //       btn checkpot-cart
      $('.checkpot-cart').addClass('show-btn-recharge');
      }, 200);
  });
  
})
